/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { DataContextProvider } from '@forge/data-connector';
import UtilityBillComponentSite from './UtilityBillComponent/UtilityBillComponentSite';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card, Icon, Tooltip } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import '../../../scss/KPICardTheme.scss';
import { UtilityCostType } from '../../shared/Utils/Constants';
import { ApiContext } from '../../../context/ApiContext';
import { shouldComponentNotUpdate } from '../../shared/Utils/Utils';

const UtilityBillWidgetSite = React.memo((props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext, widgetType } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const apiContext = useContext(ApiContext);
  const cardHeader =
    widgetType === UtilityCostType.site
      ? t(d.UtilityCost)
      : t(d.UTILITYCOSTOVERVIEW);

  const kpiContainer =
    apiContext.showEnergyStarWidget || apiContext.isEOSubscribed
      ? 'kpi-content-container with-energy-star'
      : 'kpi-content-container';
  return (
    <DataContextProvider config={connectorConfig}>
      <div className="utility-container kpi-card-common">
        <Card>
          <Card.Header className="kpi-header-container">
            <div style={{ marginRight: '5px' }} className="kpi-card-title">
              {cardHeader}
            </div>
            <Tooltip
              element={<Icon root="common" name="badge-info" size="small" />}
              event="hover"
              header={cardHeader}
              content={t(d.UTILITYBILLOVERVIEWTOOLTIPCONTENT)}
              position="right center"
              size="small"
            />
          </Card.Header>
          <Card.Content className={kpiContainer}>
            <UtilityBillComponentSite
              requestContext={requestContext}
              bearerToken={bearerToken}
            />
          </Card.Content>
        </Card>
      </div>
    </DataContextProvider>
  );
}, shouldComponentNotUpdate);

export default UtilityBillWidgetSite;
